// Pure rules of the DRCFO Admin Advisory Templates tab. Mirrors drcfo.backend
// `controllers/joi/adminAdvisoryTemplate.ts` (the server is the real gate).

export const NAME_MAX = 160;
export const CONTENT_MAX = 20000;

export const TEMPLATE_STATUS = { DRAFT: "draft", PUBLISHED: "published" };

export const TEMPLATE_STATUS_OPTIONS = [
  { value: "", label: "All" },
  { value: TEMPLATE_STATUS.PUBLISHED, label: "Published" },
  { value: TEMPLATE_STATUS.DRAFT, label: "Draft" },
];

/** A template from before the status field has none and was always live. */
export const templateStatusOf = (template) =>
  template?.templateStatus === TEMPLATE_STATUS.DRAFT
    ? TEMPLATE_STATUS.DRAFT
    : TEMPLATE_STATUS.PUBLISHED;

export const statusLabel = (status) =>
  status === TEMPLATE_STATUS.DRAFT ? "Draft" : "Published";

const specialityIdOf = (speciality) =>
  typeof speciality === "string" ? speciality : speciality?._id || "";

export const validateAdvisoryForm = ({ name, speciality, content }) => {
  const trimmedName = String(name ?? "").trim();
  if (!trimmedName) return "Advisory name is required";
  if (trimmedName.length > NAME_MAX) {
    return `Advisory name must be at most ${NAME_MAX} characters`;
  }
  if (!specialityIdOf(speciality)) return "Speciality is required";
  const trimmedContent = String(content ?? "").trim();
  if (!trimmedContent) return "Advisory content is required";
  if (trimmedContent.length > CONTENT_MAX) {
    return `Advisory content must be at most ${CONTENT_MAX} characters`;
  }
  return "";
};

export const buildAdvisoryPayload = ({ name, speciality, content, templateStatus }) => ({
  name: String(name ?? "").trim(),
  specialization: specialityIdOf(speciality),
  generalAdvice: String(content ?? "").trim(),
  templateStatus:
    templateStatus === TEMPLATE_STATUS.DRAFT
      ? TEMPLATE_STATUS.DRAFT
      : TEMPLATE_STATUS.PUBLISHED,
});

/** The first line(s) of the advice, for the list column. */
export const contentPreview = (content, max = 120) => {
  const text = String(content ?? "")
    .replace(/\s*\n+\s*/g, " · ")
    .trim();
  if (text.length <= max) return text;
  return `${text.slice(0, max).trimEnd()}…`;
};

export const importFailures = (data = {}) =>
  (Array.isArray(data?.results) ? data.results : [])
    .filter((item) => item?.status === "failed")
    .map((item) => ({
      row: Number(item.row) || null,
      label: String(item.name ?? "").trim(),
      reason: String(item.message ?? "Could not import this row"),
    }))
    .sort((a, b) => (a.row ?? Infinity) - (b.row ?? Infinity));

export const importSummary = (data = {}) => {
  const { created = 0, updated = 0, skipped = 0, failed = 0 } = data || {};
  return {
    level: failed > 0 ? "warning" : "success",
    message: `Import complete — ${created} created, ${updated} updated, ${skipped} skipped, ${failed} failed.`,
  };
};
